
export default {
  // Navbar
  "nav.home": "Inicio",
  "nav.about": "Nosotros",
  "nav.services": "Servicios",
  "nav.portfolio": "Portafolio",
  "nav.contact": "Contacto",
  "nav.start": "Comenzar",

  // Hero
  "hero.subtitle": "Aquí es donde comienza su viaje. Más fácil. Más rápido. Más confiable.",
  "hero.cta": "Explorar Ahora",
  "hero.calls": "Llamadas",
  "hero.message": "Mensaje",
  "hero.whatsapp": "WhatsApp",

  // Services
  "services.title": "NUESTROS SERVICIOS",
  "services.description": "Brindamos servicios de transporte de carga confiables y eficientes en todo Estados Unidos. Nuestros camiones tipo box están completamente equipados para manejar entregas comerciales, recolecciones programadas y envíos urgentes con puntualidad y cuidado profesional.",
  "services.freight.title": "Servicios de Transporte de Carga",
  "services.freight.item1": "Transporte de carga seca y general",
  "services.freight.item2": "Entregas locales y regionales",
  "services.freight.item3": "Manejo responsable de la carga",
  "services.freight.item4": "Cumplimiento de tiempos y rutas establecidas",
  "services.logistics.title": "Servicios Logísticos",
  "services.logistics.item1": "Coordinación y planificación de cargas",
  "services.logistics.item2": "Seguimiento y control de envíos",
  "services.logistics.item3": "Comunicación constante con el cliente",
  "services.logistics.item4": "Documentación y gestión operativa",
  "services.commitment.title": "Compromiso Operativo",
  "services.commitment.item1": "Operaciones seguras y confiables",
  "services.commitment.item2": "Cumplimiento de regulaciones federales y estatales",
  "services.commitment.item3": "Atención profesional y personalizada",
  "services.commitment.item4": "Respuesta rápida y servicio eficiente",

  // Portfolio / Trust
  "portfolio.title": "Su carga en manos profesionales. Su tranquilidad es nuestra prioridad.",
  "portfolio.description": "Nosotros nos encargamos de su carga, con un servicio profesional, seguro y confiable.",

  // Coverage
  "coverage.title": "COBERTURA",
  "coverage.p1": "SunRoute Group está cubriendo más territorio que nunca. Ofrecemos nuestros servicios en todo Estados Unidos, brindándole el respaldo que su operación necesita, sin importar dónde se encuentre.",
  "coverage.p2": "Contamos con una red operativa estratégicamente posicionada, lo que nos permite garantizar tiempos de respuesta rápidos, entregas eficientes y servicio de alta calidad en cada región. Nuestro compromiso es estar cerca de usted y de su carga, siempre que nos necesite.",

  // Why Choose Us
  "why.title": "¿POR QUÉ ELEGIRNOS?",
  "why.security.title": "Seguridad y cumplimiento",
  "why.security.desc": "Operamos con los más altos estándares de seguridad.",
  "why.delivery.title": "Entregas puntuales",
  "why.delivery.desc": "Cumplimos con los tiempos acordados siempre.",
  "why.operation.title": "Operación eficiente",
  "why.operation.desc": "Procesos optimizados para máxima eficiencia.",
  "why.support.title": "Atención confiable",
  "why.support.desc": "Soporte dedicado cuando lo necesites.",

  // Contact
  "contact.badge": "CONTACTO",
  "contact.title": "CONTÁCTANOS",
  "contact.description": "Estamos a su disposición para asistirle. Complete el formulario y nos pondremos en contacto con usted a la brevedad posible.",
  "contact.info.phone": "Teléfono",
  "contact.info.email": "Correo Electrónico",
  "contact.info.location": "Ubicación",
  "contact.info.whatsapp": "Escríbenos por WhatsApp",
  "contact.info.hours.title": "Horario de Atención",
  "contact.info.hours.everyday": "Todos los Días",
  "contact.info.hours.available": "Disponibles 24 horas al día, 7 días a la semana",
  "contact.form.title": "Envíanos un Mensaje",
  "contact.form.subtitle": "Responderemos en menos de 24 horas",
  "contact.form.name": "Nombre Completo",
  "contact.form.name.placeholder": "Tu nombre completo",
  "contact.form.email": "Correo Electrónico",
  "contact.form.email.placeholder": "tu@email.com",
  "contact.form.phone": "Teléfono",
  "contact.form.phone.placeholder": "(123) 456-7890",
  "contact.form.company": "Empresa",
  "contact.form.company.placeholder": "Nombre de tu empresa",
  "contact.form.service": "Servicio de Interés",
  "contact.form.service.select": "Selecciona un servicio",
  "contact.form.service.freight": "Transporte de Carga",
  "contact.form.service.logistics": "Servicios Logísticos",
  "contact.form.service.consulting": "Consultoría Operativa",
  "contact.form.service.other": "Otro",
  "contact.form.message": "Mensaje",
  "contact.form.message.placeholder": "Cuéntanos cómo podemos ayudarte con tu carga o logística...",
  "contact.form.message.hint": "Describe tu necesidad con el mayor detalle posible",
  "contact.form.submit": "Enviar Mensaje",
  "contact.form.sending": "Enviando...",
  "contact.form.privacy": "Tu información está segura. No compartimos tus datos con terceros.",
  "contact.form.success.title": "¡Mensaje enviado con éxito!",
  "contact.form.success.desc": "Nos pondremos en contacto contigo pronto. Revisa tu correo.",
  "contact.form.error.name": "Por favor ingresa tu nombre completo.",
  "contact.form.error.email": "Por favor ingresa un correo electrónico válido.",
  "contact.form.error.message": "Por favor escribe un mensaje.",
  "contact.form.error.maxlength": "El mensaje no puede exceder los 500 caracteres.",
  "contact.form.error.general": "Hubo un error al enviar. Por favor intenta de nuevo.",

  // About
  "about.title": "SOBRE NOSOTROS",
  "about.p1": "Somos una empresa de transporte de carga comprometida con brindar soluciones logísticas seguras, eficientes y confiables. Nos especializamos en el traslado de mercancía, garantizando puntualidad, responsabilidad y un alto estándar de servicio en cada entrega.",
  "about.p2": "Nuestro equipo trabaja con profesionalismo y dedicación, utilizando procesos eficientes y cumpliendo con todas las normativas del sector, con el objetivo de asegurar que cada carga llegue a su destino en óptimas condiciones. Entendemos la importancia de la confianza en el transporte de mercancía, por lo que nos enfocamos en ofrecer un servicio transparente, responsable y orientado a las necesidades de nuestros clientes.",
  "about.p3": "En nuestra empresa, la seguridad, la eficiencia y el compromiso son la base de cada operación.",

  // Footer
  "footer.contact": "CONTÁCTANOS",
  "footer.rights": "Todos los derechos reservados."
};
